export interface CepAddress {
  logradouro: string
  bairro: string
  cidade: string
  uf: string
}

export function isValidCep(cep: string): boolean {
  return /^\d{8}$/.test(cep.replace('-', ''))
}

/**
 * Consulta o ViaCEP. Retorna o endereço no sucesso, ou `null` em qualquer
 * falha (CEP inexistente, rede, timeout, serviço fora) — NUNCA lança: o caller
 * degrada para preenchimento manual e nunca bloqueia o submit. Sem PII enviada.
 */
export async function lookupCep(cep: string, timeoutMs = 4000): Promise<CepAddress | null> {
  const digits = cep.replace('-', '')
  if (!isValidCep(digits)) return null
  const ctrl = new AbortController()
  const t = setTimeout(() => ctrl.abort(), timeoutMs)
  try {
    const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`, { signal: ctrl.signal })
    if (!res.ok) return null
    const data = await res.json()
    if (data?.erro) return null
    return {
      logradouro: data.logradouro ?? '',
      bairro: data.bairro ?? '',
      cidade: data.localidade ?? '',
      uf: data.uf ?? '',
    }
  } catch {
    return null
  } finally {
    clearTimeout(t)
  }
}
